/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

export function selectOption(metaDataTag, sOptionName, dataFields) {
    const selectElement = $(`#elm_widget_${metaDataTag}_${sOptionName}`)[0];

    if (!selectElement || !selectElement.selectize) {
        console.warn("Selectize not found for", `#elm_widget_${metaDataTag}_${sOptionName}`);
        return;
    }

    selectElement.selectize.on("change", function (value) {
        if (!value) {
            return;
        }
        if (typeof value !== "object") {
            value = [value];
        }

        var sel = this;

        // reset form fields
        Object.keys(dataFields).forEach((sField) => {
            $(`.dd-widget-form *[name="${metaDataTag}[${sField}]"]`).val("");
        });

        // update form fields based on selection
        value.forEach((val) => {
            if (val && sel.options[val]) {
                Object.entries(dataFields).forEach(([sField, sKey]) => {
                    if (sel.options[val][sKey]) {
                        var $field = $(`.dd-widget-form *[name="${metaDataTag}[${sField}]"]`);
                        $field.val(($field.val() !== "" ? $field.val() + ", " : "") + sel.options[val][sKey]);
                    }
                });
            }
        });
    });
}

export function selectFromData(elementId, formId, shortCodeTag, optionData, optionFields) {
    $(elementId).selectize({
        valueField: "value",
        labelField: "label",
        searchField: ["label", "description"],
        create: false,
        render: {
            option: function (item, escape) {
                let opt = '<div class="media">';
                if( item.icon )
                {
                    opt += '<div class="pull-left" style="width:32px;">' +
                        '  <img src="' + item.icon + '" class="media-object" style="max-width: 32px; max-height: 32px; margin-top: 3px;" />' +
                        '</div>';
                }
                opt +=
                    '  <div class="media-body">' +
                    '    <strong class="media-heading name">' +
                    escape(item.label) +
                    "</strong>";
                if (item.description) {
                    opt += "<br /><small>" + item.description + "</small>";
                }
                opt += "  </div>" + "</div>";
                return opt;
            },
        },
        load: function (query, callback) {
            if (!query.length) {
                return callback();
            }
            const $form = $(formId);
            const formAction = $form.attr( 'action' ) + $form.serialize();
            const url = `${formAction}&fnc=doShortCodeAction&shortcode=${shortCodeTag}&action=${optionData}&search=${encodeURIComponent(query)}`;
            $.ajax({
                url: url,
                type: "GET",
                error: function () {
                    callback();
                },
                success: function (res) {
                    callback(res);
                },
            });
        },
        onChange: function (value) {
            updateFormFields(value, this.options, shortCodeTag, optionFields);
        },
    });
}

function updateFormFields(value, options, shortCodeTag, optionFields) {
    if (value && options[value]) {
        Object.keys(optionFields).forEach(key => {
            const field = optionFields[key];
            if (options[value][field]) {
                const selector = `.dd-widget-form *[name="${shortCodeTag}[${key}]"]`;
                $(selector).val(options[value][field]);
            }
        });
    }
}
